import { render, staticRenderFns } from "./expertpayDetail.vue?vue&type=template&id=72bfaab5&scoped=true"
import script from "./expertpayDetail.vue?vue&type=script&lang=js"
export * from "./expertpayDetail.vue?vue&type=script&lang=js"
import style0 from "./expertpayDetail.vue?vue&type=style&index=0&id=72bfaab5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfaab5",
  null
  
)

export default component.exports